<template>
  <div
    class="flex-1 flex flex-col gap-1"
    v-loading="loading"
    ref="containerRef"
  >
    <div class="flex-1 relative">
      <el-scrollbar class="absolute inset-0 scroll-bar" ref="scrollbarRef">
        <AutoFitContainer
          v-if="bubbleList.length == 0"
          class="justify-center items-center content"
        >
          <PanelChatInitialOptions
            :agent="agentInfo"
            @select="handleChangeInputText"
          />
        </AutoFitContainer>
        <template v-else>
          <MessageBubble
            v-for="msg of bubbleList"
            :key="msg.sequenceNumber"
            :bubble="msg"
          />
        </template>
      </el-scrollbar>
    </div>
    <PanelFileList
      v-if="!sending"
      :files="fileList"
      @remove-file="removeFileByIndex"
    />
    <DividerHorizontal />
    <div class="flex flex-row gap-4 items-center">
      <ButtonSpeech @recognize="handleChangeInputText" />
      <ButtonAttachment @add-file="addFile" />
      <el-input
        clearable
        type="text"
        @keydown.native="($event) => onKeydown($event)"
        v-model="inputValue"
        ref="inputRef"
        class="flex-1"
      />
      <el-dropdown
        split-button
        type="primary"
        @click="sendMessage"
        @command="handleCommand"
        v-loading="sending"
      >
        <i class="el-icon-s-promotion" />
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <i class="el-icon-download" />
            Export
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import AiLogicMixin from "./AiLogicMixin";
import MessageBubble from "./MessageBubble.vue";
import { delay } from "@/utils/timeUtil";
import ButtonSpeech from "./ButtonSpeech.vue";
import AutoFitContainer from "@/components/AutoFitContainer.vue";
import PanelChatInitialOptions from "./PanelChatInitialOptions.vue";
import PanelFileList from "./PanelFileList.vue";
import DividerHorizontal from "./DividerHorizontal.vue";
import ButtonAttachment from "./ButtonAttachment.vue";

export default {
  name: "ChatPanel",
  mixins: [AiLogicMixin],
  components: {
    MessageBubble,
    ButtonSpeech,
    AutoFitContainer,
    PanelChatInitialOptions,
    DividerHorizontal,
    PanelFileList,
    ButtonAttachment,
  },
  props: {
    agentId: {
      type: [String, Number],
      required: true,
    },
    conversationId: {
      type: String,
      default: null,
    },
    showHistory: {
      type: Boolean,
      default: true,
    },
    agentParameters: {
      type: Object,
      default: () => ({}),
    },
    autoSendMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    handleChangeInputText(text) {
      this.inputValue = text;
    },
    // 只保留UI相关方法，其它逻辑都在mixin里
    scrollToBottom() {
      const scrollbar = this.$refs.scrollbarRef;
      const wrap = scrollbar?.$refs?.wrap;
      if (!wrap) return;
      wrap.scrollTop = wrap.scrollHeight;
    },
    onKeydown(event) {
      const me = this;
      if (event.key == "Enter" && !event.isComposing) {
        console.log('Enter:', event);
        me.sendMessage();
      }
    },
    async init() {
      const me = this;
      me.$refs.inputRef && me.$refs.inputRef.focus();
      await me.initializeAI({
        agentId: me.agentId,
        conversationId: me.conversationId,
        promptPara: me.agentParameters,
      });
      // 自动发送消息
      if (
        me.autoSendMessage &&
        typeof me.autoSendMessage === "string" &&
        me.autoSendMessage.trim()
      ) {
        me.inputValue = me.autoSendMessage;
        await me.sendMessage();
      }
    },
    newConversation() {
      const me = this;
      me.$refs.inputRef && me.$refs.inputRef.focus();
      me.destroyAI();
      me.init();
      me.$emit("new-conversation");
    },
    handleCommand(item) {
      console.log(item);
      this.exportChatHistory();
    },
  },
  mounted() {
    const me = this;
    me.$on("scroll-to-bottom", async () => {
      await delay(100);
      me.scrollToBottom();
    });
    me.init();
    if (me.showHistory) {
      me.loadHistories();
    }
    window.vm = me;
  },
  beforeDestroy() {
    const me = this;
    me.$off("scroll-to-bottom");
    me.destroyAI();
  },
};
</script>

<style scoped>
.scroll-bar {
  flex: 1 1 0;
}

.scroll-bar ::v-deep .el-scrollbar__wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}

.content {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px 8px 8px;
}

.content .message-list {
  /* 撑满剩余高度 */
  flex: 1;
  overflow-y: auto;
  padding: 36px 13px 0 13px;
  scroll-behavior: smooth;
}

.bottom-input {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 0 8px;
  border-top: 1px solid #f0f0f0;
}

input {
  height: 38px;
  border-radius: 2px;
  border: 1px solid #d2d2d2;
  margin-right: 10px;
  transition: all 0.2s ease-in-out;
}

input:focus {
  outline: none;
  border-color: #fcb900;
}

.submit-button {
  width: 56px;
  height: 38px;
  border-radius: 2px;
  background-color: #fcb900;
  opacity: 0.6;
  transition: all 0.2s ease-in-out;
}

input:focus ~ .submit-button {
  opacity: 1;
}

.submit-button img {
  width: 22px;
  height: 22px;
  margin: 8px 17px 8px 17px;
}
</style>
